import Card from "components/card";
import React, { useEffect } from "react";
import InputField from "components/fields/InputField";
import { useNavigate } from "react-router-dom";
import { HiUserAdd } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "components/pagination";
import Loader from "components/loader";
import TooltipHorizon from "components/tooltip";
import { fetchUsers } from "services/users/userSlice";
import Alert from "components/alert";
import { setCurrentPage } from "services/users/userSlice";
import { setSearch } from "services/users/userSlice";
import { setRole } from "services/users/userSlice";
import { setUser } from "services/users/userAddEditSlice";

const Users = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const users = useSelector((state) => {
    return state.user;
  });
  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const getRoles = (u) => {
    var str = "";
    if (u.is_admin) {
      str += "Админ ";
    }
    if (u.is_manager) {
      str += "Менежер ";
    }
    if (u.is_teacher) {
      str += "Багш ";
    }
    if (u.is_student) {
      str += "Сурагч ";
    }

    if (u.is_chef) {
      str += "Тогооч ";
    }
    if (u.is_food_technologist) {
      str += "Хоол технологич ";
    }
    if (u.is_parent) {
      str += "Асран хамгаалагч ";
    }
    return str;
  };

  return (
    <div>
      <Card extra={"w-full h-full p-4  mt-4"}>
        <div className="relative flex items-center justify-between mb-4">
          <div className="items-end gap-3 lg:flex ">
            <select
              value={users.role}
              onChange={(e) => {
                dispatch(setRole(e.target.value));
                dispatch(fetchUsers());
              }}
              className="flex h-12 w-auto items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
            >
              {users.role_list.map((row, index) => {
                return (
                  <option key={index} value={row.id}>
                    {row.text}
                  </option>
                );
              })}
            </select>
            <InputField
              key={"searchInput"}
              value={users.search}
              placeholder="Хэрэглэгчийн нэрээр хайх "
              className="focus:shadow-outline w-full outline-none transition-all duration-700 ease-in-out lg:w-80 lg:focus:w-96 "
              onChange={(e) => {
                dispatch(setSearch(e.target.value));
                dispatch(fetchUsers());
              }}
            />
          </div>
          <button
            onClick={() => {
              navigate("/admin/user_add", { state: { type: "register" } });
            }}
            className={`flex items-center text-xl hover:cursor-pointer ${"bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"} linear justify-center rounded-lg font-bold transition duration-200`}
          >
            <HiUserAdd className="h-6 w-6" />
          </button>
        </div>
        {users.loading && <Loader />}
        {!users.loading && users.error ? <Alert text={users.error} /> : null}
        {!users.loading && users.data.length ? (
          <div className="h-full overflow-x-scroll xl:overflow-hidden">
            <table className="responsive_table" color="gray-500" mb="24px">
              <thead>
                <tr key={"u-header"}>
                  {users.headers.map((column, index) => (
                    <th key={"user-header" + index}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {users.data.map((row, i) => {
                  return (
                    <tr key={i}>
                      <td data-label="№">
                        {(users.current_page - 1) * 30 + i + 1}
                      </td>
                      <td data-label="Хэрэглэгчийн нэр">
                        <button
                          onClick={() => {
                            dispatch(setUser(row));
                            navigate("/admin/user_edit/" + row.id);
                          }}
                          className="text-blue-800 underline hover:text-blue-600 dark:text-white "
                        >
                          {row.username}
                        </button>
                      </td>
                      <td data-label="Овог">{row.lastname}</td>
                      <td data-label="Нэр">{row.firstname}</td>
                      <td data-label="Регистр">
                        {row.register ? row.register : "-"}
                      </td>
                      <td data-label="Имэйл">
                        <TooltipHorizon
                          trigger={
                            <p className="text-ellipsis overflow-hidden dark:text-white">
                              {row.email ? row.email : "-"}
                            </p>
                          }
                          content={
                            <p className="dark:text-white">
                              {row.email ? row.email : "-"}
                            </p>
                          }
                          placement="top"
                          extra="custom-class"
                        />
                      </td>
                      <td data-label="Утас">
                        <TooltipHorizon
                          trigger={
                            <p className="text-ellipsis overflow-hidden dark:text-white">
                              {row.phone ? row.phone : "-"}
                            </p>
                          }
                          content={
                            <p className="dark:text-white">
                              {row.phone ? row.phone : "-"}
                            </p>
                          }
                          placement="top"
                          extra="custom-class"
                        />
                      </td>
                      <td data-label="Эрх">{getRoles(row)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <Pagination
              current={users.current_page}
              total={users.total_page}
              setCurrent={(index) => {
                dispatch(setCurrentPage(index));
                dispatch(fetchUsers());
              }}
            />
          </div>
        ) : null}
      </Card>
    </div>
  );
};

export default Users;
